"use client";

import React from "react";
import { Briefcase, Code, Layers, Lightbulb, LineChart, Smartphone } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Diagnostic Precision",
  description: "We utilize advanced assessment protocols to identify the root cause of your discomfort and create a targeted, results-driven recovery plan.",
  icon: LineChart
}, {
  title: "Integrated Care",
  description: "Our multidisciplinary approach combines expert spinal adjustments with rehabilitative exercises for a complete and sustainable healing experience.",
  icon: Layers
}, {
  title: "Health Advocacy",
  description: "We believe informed patients achieve better outcomes. We provide clear guidance on ergonomics, nutrition, and daily lifestyle habits.",
  icon: Lightbulb
}, {
  title: "Clinical Expertise",
  description: "Our practitioners maintain the highest standards of professional excellence, ensuring safe, effective, and reliable treatment for every patient.",
  icon: Briefcase
}, {
  title: "Patient Portal",
  description: "Access your personalized exercise routines, track recovery milestones, and schedule appointments seamlessly through our modern digital platform.",
  icon: Smartphone
}, {
  title: "Precision Techniques",
  description: "Focused manual adjustments designed to restore mobility, reduce nerve interference, and optimize your body's natural physiological function.",
  icon: Code
}];
export default function WhatWeDo() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="30663" id="our-approach" ref={ref} className="bg-background py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={cn("mb-16 text-center transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-4 tracking-tight">
            Our Clinical Approach
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans">
            Restoring vitality through evidence-based chiropractic care, personalized treatment, and a commitment to your long-term wellness.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-20">
          {services.map((service, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full bg-[#F8F8F6] border-[#E2E8F0] rounded-2xl hover:-translate-y-2 transition-all duration-300 ease-in-out group overflow-hidden shadow-sm hover:shadow-md">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center p-0 w-fit transition-colors">
                    <service.icon className="h-8 w-8 text-[#3B8FD4] stroke-[2px]" aria-hidden="true" />
                  </div>
                  <CardTitle className="font-serif text-2xl text-primary font-bold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="font-sans text-muted-foreground text-base leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}